import { useState } from 'react';
import { Modal } from '@/components/common/AppModal';
import { Button, Form, NavLink } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import Select, { components } from 'react-select';
import keywordsApi, {
  useCreateTagMutation,
  useGetTagsForSelectQuery,
  useLeaveToTagsMutation,
  useMoveToTagMutation
} from '@/app/KeywordTracker/api/keywordsApi';
import * as yup from 'yup';
import { Formik } from 'formik';
import classNames from 'classnames';
import { errorMessage, successMessage } from '@/utils/toast';
import FalconCloseButton from '@/components/common/FalconCloseButton';
import { useDispatch, useSelector } from 'react-redux';
import Flex from '@/components/common/Flex';
import { object } from 'yup';
import useDomain from '@/hooks/useDomain';
import _ from 'lodash';
import { updateTransaction } from '@/app/common/components/ag-grid/updateTransaction';
import { useSearchParams } from 'react-router-dom';
import type { GridDrawerProps } from './types';
import type { OptionProps, NoticeProps } from 'react-select';
import type { SelectOption } from './types';

const MoveToTagsForSelectedRows = ({ show, setShow, gridRef }: GridDrawerProps) => {
  const handleClose = () => setShow(false);
  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <div className="m-0">مدیریت برچسب</div>
          </div>
        </Modal.Title>
        <FalconCloseButton onClick={handleClose} />
      </Modal.Header>
      <MoveToTagsBody handleClose={handleClose} gridRef={gridRef} />
    </Modal>
  );
};

export default MoveToTagsForSelectedRows;

interface MoveToTagsBodyProps {
  handleClose: () => void;
  gridRef: GridDrawerProps['gridRef'];
}

const MoveToTagsBody = ({ handleClose, gridRef }: MoveToTagsBodyProps) => {
  const { domain_slug } = useDomain();
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);
  const selectedKeys = useSelector(state => state.selectedKeys);
  const [moveToTag] = useMoveToTagMutation();
  const [leaveToTag] = useLeaveToTagsMutation();
  const [searchParams] = useSearchParams();
  const { data: tags, isFetching: isFetchingTags } =
    useGetTagsForSelectQuery(domain_slug);
  const filters = useSelector(state => state.filters);

  return (
    <Modal.Body className="pb-0 pt-0">
      <Formik
        onSubmit={async ({ tag_ids, isMove }, action) => {
          isMove
            ? moveToTag({
                keyword_ids: selectedKeys.map(key => key.id),
                tag_ids: tag_ids.map(item => item.value),
                domain_slug
              })
                .unwrap()
                .then(res => {
                  const updatedRows = updateTransaction(res.data, gridRef);
                  // BUG? مشکل داره اگه استیت کش رو عوض کنیم جدول میره رو لودینگ
                  // dispatch(
                  //   keywordsApi.util.updateQueryData(
                  //     'getKeywords',
                  //     {
                  //       from_date: Number(searchParams.get('from_date')),
                  //       to_date: Number(searchParams.get('to_date')),
                  //       filters,
                  //       domain_slug
                  //     },
                  //     draft => {
                  //       console.log('Drafy?', draft);
                  //       updatedRows.forEach(r => {
                  //         console.log('RR:', r);
                  //         const index = draft.data.rows.findIndex(
                  //           row => row.id === r.id
                  //         );
                  //         if (index !== -1) {
                  //           draft.data.rows[index] = r;
                  //         }
                  //       });
                  //     }
                  //   )
                  // );
                  successMessage('برچسب با موفقیت به کلمات اضافه شد');
                })
                .catch(err => {
                  errorMessage('خطایی در افزودن برچسب وجود داره');
                  console.error(err);
                })
            : leaveToTag({
                keyword_ids: selectedKeys.map(key => key.id),
                tag_ids: tag_ids.map(item => item.value),
                domain_slug
              })
                .unwrap()
                .then(res => {
                  const updatedRows = updateTransaction(res.data, gridRef);
                  successMessage('برچسب با موفقیت از کلمات حذف شد');
                })
                .catch(err => {
                  errorMessage('خطایی در حذف برچسب وجود داره');
                  console.error(err);
                });
          handleClose();
        }}
        validationSchema={yup.object().shape({
          isMove: yup.boolean().required('عملیات رو مشخص کنید.'),
          tag_ids: yup
            .array()
            .of(yup.object())
            .min(1, 'حداقل یک برچسب رو انتخاب کنید.')
        })}
        initialValues={{ isMove: null, tag_ids: [], inputValue: '' }}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          setFieldError,
          setFieldValue
        }) => (
          <Form
            onSubmit={e => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <Form.Group className="my-3">
              <Form.Label>کلمات انتخاب شده ({selectedKeys.length})</Form.Label>
              <Form.Control
                // readOnly
                disabled
                rows={selectedKeys.length > 3 ? 3 : selectedKeys.length}
                as="textarea"
                value={selectedKeys.map(({ label }) => `${label}`).join('\n')}
              />
            </Form.Group>
            <Form.Group className="my-3">
              <Form.Label>انتخاب برچسب </Form.Label>
              {!isFetchingTags && tags?.data && (
                <Select
                  classNamePrefix="react-select"
                  menuShouldScrollIntoView={true}
                  menuIsOpen={menuOpen}
                  onMenuOpen={() => setMenuOpen(true)}
                  onInputChange={(newValue, { action }) => {
                    if (action !== 'input-blur' && action !== 'menu-close') {
                      setFieldValue('inputValue', newValue); // Only update input if not closing
                    } else {
                      setTimeout(() => setMenuOpen(false), 150);
                    }
                  }}
                  inputValue={values.inputValue}
                  closeMenuOnSelect={false}
                  placeholder="انتخاب کن"
                  styles={{
                    menu: (baseStyles, state) => ({
                      position: 'absolute',
                      // overflow: 'auto',
                      zIndex: 9999,
                      width: '100%'
                    }),
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      direction: 'rtl !important',
                      paddingLeft: '10px',
                      paddingRight: '10px',
                      borderColor:
                        errors.tag_ids &&
                        touched.tag_ids &&
                        'var(--falcon-form-invalid-border-color) !important',
                      color: 'var(--falcon-emphasise) !important',
                      boxShadow: 'none !important',
                      borderRadius: '5px 5px 5px 5px !important',
                      width: '100% !important',
                      cursor: 'pointer'
                    }),
                    input: (baseStyles, state) => ({
                      ...baseStyles,
                      direction: 'ltr !important',
                      color: 'var(--falcon-emphasise) !important',
                      boxShadow: 'none !important'
                    })
                  }}
                  components={{
                    Option: OptionLayout,
                    NoOptionsMessage: props => (
                      <NoOptionsMessage
                        {...props}
                        setFieldValue={setFieldValue}
                        setFieldError={setFieldError}
                      />
                    )
                  }}
                  onChange={e => {
                    setFieldValue('tag_ids', e);
                  }}
                  isMulti
                  value={values.tag_ids}
                  isSearchable={true}
                  noOptionsMessage={() => 'یافت نشد'}
                  options={tags.data}
                />
              )}
              <Form.Control.Feedback
                className="d-block"
                type={errors.tag_ids || errors.inputValue ? 'invalid' : 'valid'}
              >
                {(touched.tag_ids || errors.inputValue) &&
                  (errors.tag_ids || errors.inputValue)}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Label>عملیات</Form.Label>
            <Flex className="gap-3 flex-wrap">
              <Form.Check
                isInvalid={errors.isMove}
                type="radio"
                className="form-check radio-select"
              >
                <Form.Check.Input
                  isInvalid={errors.isMove}
                  onChange={({ target }) => {
                    target.checked && setFieldValue('isMove', true);
                  }}
                  checked={values.isMove}
                  type="radio"
                  id="add"
                />
                <Form.Check.Label htmlFor="add">
                  اضافه به برچسب{' '}
                </Form.Check.Label>
              </Form.Check>{' '}
              <Form.Check type="radio" className="form-check radio-select">
                <Form.Check.Input
                  isInvalid={errors.isMove}
                  onChange={({ target }) => {
                    target.checked && setFieldValue('isMove', false);
                  }}
                  checked={values.isMove === false}
                  type="radio"
                  id="remove"
                />
                <Form.Check.Label htmlFor="remove">
                  خروج از برچسب
                </Form.Check.Label>
              </Form.Check>
            </Flex>
            <Form.Control.Feedback
              className="d-block mt-n2 mb-2"
              type={errors.isMove ? 'invalid' : 'valid'}
            >
              {touched.isMove && errors.isMove}
            </Form.Control.Feedback>
            {/* دکمه های آخر صفحه */}
            <Modal.Footer>
              <Button
                className="d-flex gap-2 align-items-center"
                variant="outline-secondary"
                onClick={handleClose}
              >
                <FontAwesomeIcon size="lg" icon="times" />
                لغو
              </Button>
              <Button
                className="d-flex gap-2 align-items-center border-0"
                // onClick={() => handleSubmit()}
                type="submit"
                variant="falcon-primary"
              >
                اعمال کن
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal.Body>
  );
};

const OptionLayout = (props: OptionProps<SelectOption>) => {
  const { innerProps, innerRef } = props;
  return (
    <>
      <style>{`
          .customized-searchbox-option:hover{
            background-color:var(--falcon-gray-link-hover-300) !important;
          }
          .customized-searchbox-option{
            background-color:var(--falcon-tertiary-bg) !important;
          }
          `}</style>
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          backgroundColor: props.isSelected
            ? 'var(--falcon-gray-link-hover-100)'
            : 'var(--falcon-dropdown-bg-global)'
        }}
        className={classNames(
          'p-2 cursor-pointer border border-1 customized-searchbox-option',
          {}
        )}
      >
        <div className="fs-0 text-900">{props.data.label}</div>
      </div>
    </>
  );
};

interface NoOptionsMessageProps extends NoticeProps<SelectOption, true> {
  setFieldValue: (field: string, value: unknown) => void;
  setFieldError: (field: string, message: string | undefined) => void;
}

const NoOptionsMessage = (props: NoOptionsMessageProps) => {
  const { data: userInfo, isLoading, isError } = useGetUserInfoQuery();
  const { domain_slug, domain } = useDomain();
  const [createTag] = useCreateTagMutation();
  const inputValue = props.selectProps.inputValue;
  const setInptut = value => props.setFieldValue('inputValue', value);
  return (
    <components.NoOptionsMessage {...props}>
      <Formik
        onSubmit={async ({ title }, action) => {
          createTag({
            title: title.trim(),
            keyword_ids: [],
            domain_slug
          })
            .unwrap()
            .then(res => {
              if (res?.success) {
                successMessage('برچسب با موفقیت اضافه شد');
                setInptut('');
              } else if (res?.resultCode === 50004)
                errorMessage('برچسب با این عنوان وجود داره');
            })
            .catch(err => {
              errorMessage('خطایی در ایجاد تگ وجود داره');
              console.error(err);
            });
          // setShow(false);
        }}
        initialValues={{ title: inputValue, keyword_ids: [] }}
        enableReinitialize
        validationSchema={object().shape({
          // keyword_ids: array().required('وارد کردن'),
          title: yup
            .string()
            .trim()
            .required('لطفا نام برچسب رو بنویسید.')
            .max(50, 'نام برچسب نباید بیشتر از ۵۰ کاراکتر باشد.')
        })}
      >
        {({ handleSubmit, errors }) => {
          if (errors.title) props.setFieldError('inputValue', errors.title);
          return (
            !isLoading && (
              <div
                className="d-flex  fs--1 align-items-center gap-2 justify-content-center"
                onMouseDown={e => e.stopPropagation()} // Prevent react-select focus
                onClick={e => e.stopPropagation()} // Prevent react-select focus
              >
                <div>یافت نشد!</div>
                <NavLink
                  className="d-flex border-bottom bordrer-1 navLinkForceColor active nav-link gap-1 justify-content-center align-items-center"
                  onClick={e => {
                    e.stopPropagation();
                    handleSubmit();
                  }}
                >
                  اضافه کن
                </NavLink>
              </div>
            )
          );
        }}
      </Formik>
    </components.NoOptionsMessage>
  );
};
